// Auto-rollback watch countdown helpers (DEVOPS-1629).
//
// There is no persisted watch deadline; the watch runs for a fixed window
// anchored at deploy start. The baseline snapshot captures that anchor
// (`anchored_at`) and the window length (`window_seconds`, typically 900), so a
// `watching` row counts down to `anchored_at + window_seconds`.

import { DeploymentRecord } from '../../types/DeploymentRecord';

const DEFAULT_WATCH_WINDOW_SECONDS = 15 * 60;

/**
 * Milliseconds left in the watch window for a `watching` record, clamped to 0,
 * or null when the row isn't watching or has no baseline anchor to count from.
 */
export const watchRemainingMs = (record: DeploymentRecord, now: number): number | null => {
  if (record.watch_state !== 'watching') return null;
  const anchor = record.baseline_snapshot?.anchored_at;
  if (!anchor) return null;
  const start = Date.parse(anchor);
  if (Number.isNaN(start)) return null;
  const windowSeconds = record.baseline_snapshot?.window_seconds ?? DEFAULT_WATCH_WINDOW_SECONDS;
  const deadline = start + windowSeconds * 1000;
  return Math.max(0, deadline - now);
};

/** Human countdown like "12m 30s" or "45s". */
export const formatCountdown = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
};
